export enum PageRoute {
  AnalyticsEmbedEngagement = 'analytics-embed-engagement',
  AnalyticsEmbedRevenue = 'analytics-embed-revenue',
  AnalyticsEmbedModeration = 'analytics-embed-moderation'
}
